/**
 * Profileオブジェクトを生成する
 * キャメルケース
 * @param {Object} row
 * @returns {import('@/types/Profile').Profile}
 */
export function createProfile(row) {

    return {
        id: row.id,
        userName: row.username,
        roleId: row.role_id,
        birthday: row.birthday,

        createdAt: new Date(row.created_at),
        updatedAt: new Date(row.updated_at),
        deletedAt: row.deleted_at ? new Date(row.deleted_at) : null,

        isEditing: false,
        originalUser: row.user,
    }
}